import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { memo } from 'react';
import { styled, StyleSheet, useToken, text, icon, padding } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import CheckSmallIcon from '@rexlabs/icons/check-small.svg';
var defaultStyles = StyleSheet({
  container: _objectSpread(_objectSpread(_objectSpread({
    cursor: 'pointer'
  }, text.styles({
    target: ['select.option', 'select.menuItem'],
    fallback: 'normal.default'
  })), padding.styles({
    target: ['select.option', 'select.menuItem'],
    x: 'm',
    y: 's'
  })), {}, {
    minHeight: function minHeight(_ref) {
      var token = _ref.token;
      return token('select.option.minHeight', token('select.menuItem.minHeight', '4.4rem'));
    },
    backgroundColor: function backgroundColor(_ref2) {
      var token = _ref2.token;
      return token('select.option.background.color', token('color.container.interactive.idle'));
    }
  }),
  isHighlighted: {
    backgroundColor: function backgroundColor(_ref3) {
      var token = _ref3.token;
      return token('select.option.hover.background.color', token('select.menuItem.hover.background.color', token('color.container.interactive.hover')));
    }
  },
  isSelected: {
    backgroundColor: function backgroundColor(_ref4) {
      var token = _ref4.token;
      return token('select.option.selected.background.color', token('select.menuItem.selected.background.color'));
    }
  },
  description: _objectSpread({}, text.styles({
    target: ['select.option.subText', 'select.menuItem.subText'],
    fallback: 'small.default',
    color: function color(_ref5) {
      var token = _ref5.token;
      return token('color.textStyle.body.subtext');
    }
  })),
  truncate: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  icon: {
    '& > svg': _objectSpread({}, icon.styles({
      target: ['select.option', 'select.menuItem'],
      size: 'm'
    }))
  }
});

var DefaultOptionInner = function DefaultOptionInner(_ref6) {
  var s = _ref6.styles,
      Option = _ref6.Option,
      props = _objectWithoutProperties(_ref6, ["styles", "Option"]);

  var item = props.item,
      isHighlighted = props.isHighlighted,
      isSelected = props.isSelected,
      rest = _objectWithoutProperties(props, ["item", "isHighlighted", "isSelected"]);

  var token = useToken();
  var Icon = item === null || item === void 0 ? void 0 : item.Icon;
  var label = item === null || item === void 0 ? void 0 : item.label;
  var description = item === null || item === void 0 ? void 0 : item.description;
  return Option ? /*#__PURE__*/React.createElement(Option, props) : /*#__PURE__*/React.createElement(Box, _extends({}, rest, s.with('container', {
    isHighlighted: isHighlighted,
    isSelected: isSelected
  })(props), {
    flex: 1,
    flexDirection: "row"
  }), Icon && /*#__PURE__*/React.createElement(Box, _extends({}, s('icon'), {
    flex: 0,
    alignItems: "center",
    marginRight: token('spacing.s')
  }), /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement(Box, {
    style: {
      overflow: 'hidden'
    },
    flex: 1,
    alignItems: "space-between",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(Box, _extends({}, s('truncate'), {
    title: label
  }), label), description && /*#__PURE__*/React.createElement(Box, _extends({}, s('description', 'truncate'), {
    title: description
  }), description)), isSelected && /*#__PURE__*/React.createElement(Box, _extends({}, s('icon'), {
    flex: 0,
    alignItems: "center",
    marginLeft: token('spacing.s')
  }), /*#__PURE__*/React.createElement(CheckSmallIcon, null)));
};

var StyledDefaultOptionInner = styled(defaultStyles)(DefaultOptionInner);
export default /*#__PURE__*/memo(StyledDefaultOptionInner);